// extracted by mini-css-extract-plugin
export var callCard = "_pv-0";
export var callMessageButton = "_pv-1";
export var helpIcon = "_pv-3";
export var helpIconContainer = "_pv-4";
export var verticalDivider = "_pv-2";